__turbopack_context__.v({
  "cell": "skeleton-module__J7gWsW__cell",
  "headerCell": "skeleton-module__J7gWsW__headerCell",
  "shimmer": "skeleton-module__J7gWsW__shimmer",
  "skeleton": "skeleton-module__J7gWsW__skeleton",
  "table": "skeleton-module__J7gWsW__table",
  "textLine": "skeleton-module__J7gWsW__textLine",
});
